import { Classification } from "../../../../models/data/blobby/classification.data";
import { ClassificationStoreModel } from "../../../../models/store/classification.store.model";

type ClassificationModelV1 = Omit<ClassificationStoreModel, "v"> & {
  v: 1;
  w: number; // weight
};

export const classification_v0_to_v1 = (
  classificationItem: Classification,
): ClassificationModelV1 => {
  return {
    dc: new Date().toString(),
    dm: new Date().toString(),
    gd: classificationItem.generalDefault,
    id: classificationItem.id,
    n: classificationItem.name,
    v: 1,
    vid: "",
    w: classificationItem.weight,
  };
};

export const classification_v1_to_v2 = (
  classification: ClassificationModelV1,
): ClassificationStoreModel => {
  delete classification.w; // remove weight property
  return {
    ...classification,
    v: 2,
  };
};
